import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Header from './components/Header';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import './management_layout_v4.css';
import './mobile_layout_v72.css';
import { UserProvider } from './context/User';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StatusProvider } from './context/Status';
import { SystemBrandingProviderV9 } from './context/SystemBrandingV9';
import './i18n';
import { ThemeProviderV81 } from './context/ThemeV81';
import ScrollRestorationV81 from './components/ScrollRestorationV81';
import './ui_foundation_v81.css';
import './acuverse_v9.css';
import './acuverse_layout_v101.css';

document.documentElement.dataset.edition = 'acuverse';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProviderV81>
      <StatusProvider>
        <SystemBrandingProviderV9>
          <UserProvider>
            <BrowserRouter>
              <ScrollRestorationV81 />
              <Header>
                <App />
              </Header>
              <ToastContainer />
            </BrowserRouter>
          </UserProvider>
        </SystemBrandingProviderV9>
      </StatusProvider>
    </ThemeProviderV81>
  </React.StrictMode>
);
